{
  "salon-search-form": {
    "buttons": {
      "customize": "Advanced filter",
      "search": "SEARCH"
    },
    "text": {
      "city": "City",
      "date": "Date",
      "treatment": "Treatment"
    }
  }
}
